import { render } from "./Breadcrumbs.vue?vue&type=template&id=6df4dbc1&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=6df4dbc1&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df4dbc1"]])

export default __exports__